import "./login.scss";
import Star from "assets/authentication/login-star.svg";
import LoginForm from "../login-form/login-form";
import { useEffect, useState } from "react";
import ForgotPasswordForm from "../forgot-password-form/forgot-password-form";
import FirstLoginForm from "../first-login-form/first-login-form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppRoutes } from "../../types/app-routes";
import LoginBackground from "assets/authentication/login-background.svg";
import SignInForm from "../sign-in-form/sign-in-form"

export enum FormState {
  Login = "Login",
  FirstLogin = "FirstLogin",
  ForgotPassword = "ForgotPassword",
  SignIn = "SignIn",
}

const Login = () => {
  const navigate = useNavigate();
  const dispatch: Function = useDispatch();
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );
  const isFirstLogin = useSelector((state: any) => state.auth.user?.firstLogin);
  const [formState, setFormState] = useState<FormState>(FormState.Login);
  const formDict = {
    [FormState.Login]: <LoginForm setFormState={setFormState} />,
    [FormState.FirstLogin]: <FirstLoginForm />,
    [FormState.ForgotPassword]: (
      <ForgotPasswordForm setFormState={setFormState} />
    ),
    [FormState.SignIn]: <SignInForm setFormState={setFormState} />
  };

  useEffect(() => {
    if (isAuthenticated && !isFirstLogin) navigate(AppRoutes.STOCK_MANAGEMENT+'/ice-cream');
  }, [isAuthenticated]);

  return (
    <div className="login">
      <div className="login__company-container">
      <div className="login__company-container-mask">
        <img src={Star} alt="Star" className="login__company-container-mask__star"/>
        <div className="login__company-container-mask__title">Welcome to Amorino !</div>
        <div className="login__company-container-mask__subtitle">
        Get full access to your inventory and your stock.
        </div>
      </div>
      </div>
      <div className="login__form-container">{formDict[formState]}</div>
    </div>
  );
};

export default Login;
